import CalculetteCommon, { JOUR_TRAV_AN, PRIX_LICENCE } from './calculette-common';

const Turnover = {
    init() {
        const nbTech = $('#calc-turnover-nb-tech');
        const nbInterventionTech = $('#calc-turnover-int-tech');
        const factMoyInt = $('#calc-turnover-fact-int');
        const ctaHubspotTurnover = $('#cta-hubspot-turnover > a');
        const simulationHubspotBlock = $('.js-simulation-hubspot-related');
        const turnoverForm = $('.js-form-turnover');

        if (!!turnoverForm.length) {
            CalculetteCommon.alterSubmitButtonAppearance(turnoverForm);
            $(window).on(
                'resize', function () {
                    CalculetteCommon.alterSubmitButtonAppearance(turnoverForm);
                }
            );
            CalculetteCommon.handleFocusInput(turnoverForm);
            
            turnoverForm.on(
                'submit', function (e) {
                    e.preventDefault();
                    Turnover.submitForm(nbTech, nbInterventionTech, factMoyInt, turnoverForm, simulationHubspotBlock);
                }
            );

            if (ctaHubspotTurnover.length) {
                ctaHubspotTurnover.on(
                    'click', function (e) {
                        e.preventDefault();
                        Turnover.collectHubspotTurnoverVariables($(this), nbTech, nbInterventionTech, factMoyInt);
                    }
                );
            }

            nbTech.on(
                'input', function () {
                    CalculetteCommon.validateInputOnChange($(this), turnoverForm);
                }
            );

            nbInterventionTech.on(
                'input', function () {
                    CalculetteCommon.validateInputOnChange($(this), turnoverForm);
                }
            );

            factMoyInt.on(
                'input', function () {
                    CalculetteCommon.validateInputOnChange($(this), turnoverForm);
                }
            );
        }
    },

    submitForm(nbTech, nbInterventionTech, factMoyInt, form, simulationHubspotBlock) {
        form.data('submit', 'submitted');
        const formStatusInputs = [
            CalculetteCommon.validateInputOnSubmit(nbTech, form),
            CalculetteCommon.validateInputOnSubmit(nbInterventionTech, form),
            CalculetteCommon.validateInputOnSubmit(factMoyInt, form),
        ];

        if (formStatusInputs.includes(false)) {
            form.data('valid', '');
        } else {
            form.data('valid', 'valid');
        }

        if (form.data('valid') === 'valid') {
            const simulatorSection = $('#simulation-turnover');
            const resultEltWrapper = $('.turnover .simulation__result .valid');
            const resultFirstElt = resultEltWrapper.find('.first-result');
            const resultSecondElt = resultEltWrapper.find('.second-result');
            const resultZero = $('.turnover .simulation__result .zero');
            const turnover5percent = Turnover.calculateTurnover(nbTech, nbInterventionTech, factMoyInt, .05);
            const turnover15percent = Turnover.calculateTurnover(nbTech, nbInterventionTech, factMoyInt, .15);

            CalculetteCommon.displayValidResult(turnover5percent, turnover15percent, resultEltWrapper, resultFirstElt, resultSecondElt, resultZero, simulatorSection);
            simulationHubspotBlock.css('display', 'block');
        } else {
            simulationHubspotBlock.css('display', 'none');
        }
    },
    
    collectHubspotTurnoverVariables(ctaHubspot, nbTech, nbInterventionTech, factMoyInt) {
        const urlParams = new URLSearchParams();
        const hubspotUrl = ctaHubspot.attr('href');

        urlParams.set('nombre_de_technciens', nbTech.val());
        urlParams.set('nombre_d_interventions_par_jour_par_technicien', nbInterventionTech.val());
        urlParams.set('facture_moyenne_intervention', factMoyInt.val());
        urlParams.set('previsionnel_ca', CalculetteCommon.simulationResultText);

        if (hubspotUrl.includes('?')) {
            location.href = hubspotUrl + '&' + urlParams.toString();
        } else {
            location.href = hubspotUrl + '?' + urlParams.toString();
        }
    },

    calculateTurnover(nbTechnicien, nbIntTech, facture, shadow) {
        const nbTech = parseFloat(nbTechnicien.val());
        const nbInterventionTech = parseFloat(nbIntTech.val());
        const factMoyInt = parseFloat(facture.val());
        const nbPlanificateur = nbTech * 0.1;

        //Constantes intermediaires
        const nbInterventionJour = nbTech * nbInterventionTech;
        const nbInterventionAn = nbTech * nbInterventionTech * JOUR_TRAV_AN;
        const nbInterventionJourShadow = nbInterventionJour + (nbInterventionJour * shadow);
        const coutSolution = (nbTech + nbPlanificateur) * PRIX_LICENCE * 12;
        const caEnPlus = (nbInterventionJourShadow * JOUR_TRAV_AN) - nbInterventionAn;
        const caEnPlusShadow = caEnPlus * factMoyInt;

        //résultat final
        return Math.round(caEnPlusShadow - coutSolution);
    },
};

export default Turnover;
